import { render, staticRenderFns } from "./cv-aspect-ratio.vue?vue&type=template&id=c09e0870&"
import script from "./cv-aspect-ratio.vue?vue&type=script&lang=js&"
export * from "./cv-aspect-ratio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports